// extracted by mini-css-extract-plugin
module.exports = {"loginTitle":"_3Udab","confirmBody":"_90Ms5"};